import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button
} from 'semantic-ui-react'

const CardPayrollSalaryTabUX = (props: any) => {
    return(
      <div
        id="CardPayrollSalaryTabUX-div-0"
        style={{paddingBottom: '40px'}}>
        <div
          id="CardPayrollSalaryTabUX-div-1"
          style={{paddingLeft:'20px'}}>

          <div
            id="CardPayrollSalaryTabUX-div-2"
            style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '20px', paddingBottom: 0, marginTop: '20px', fontWeight: 'bold' }}>
            {props.languageUX === "en" ? "Salary Pay" : "การจ่ายเงินเดือน"}
          </div>
          <hr
            id="CardPayrollSalaryTabUX-hr-3">
          </hr>
          <div
            id="CardPayrollSalaryTabUX-div-4"
            style={{marginTop: '10px'}}>

            <div
              id="CardPayrollSalaryTabUX-div-5"
              style={{display: 'flex'}}>

              <Button
                id="CardPayrollSalaryTabUX-Button-6"
                onClick={props.onClickCreateSalary}
                style={props.getCreateSalaryTabStyle}>
                {props.languageUX === "en" ? "Create Salary Pay Run" : "สร้างการรันเงินเดือน"}
              </Button>
              <Button
                id="CardPayrollSalaryTabUX-Button-7"
                onClick={props.onClickSalaryPayRun}
                style={props.getSalaryPayRunTabStyle}>
                {props.languageUX === "en" ? "Salary Pay Run" : "การจ่ายเงินเดือน"}
              </Button>
            </div>
            <div
              id="CardPayrollSalaryTabUX-div-8"
              style={{ height: '2px', backgroundColor: '#ccc', width: '100%' }}>

            </div>
            <div
              id="CardPayrollSalaryTabUX-div-9">
              {props.renderSalaryTab()}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardPayrollSalaryTabUX

export const screenPropsDefault = {}

/* Date Time : Tue Aug 19 2025 09:33:13 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayrollSalaryTabUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{paddingBottom: '40px'}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayrollSalaryTabUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:'20px'}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "การจ่ายเงินเดือน",
          "valueEN": "Salary Pay"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollSalaryTabUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '20px', paddingBottom: 0, marginTop: '20px', fontWeight: 'bold' }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayrollSalaryTabUX-hr-3"
        }
      },
      "seq": 3,
      "void": true
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayrollSalaryTabUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: '10px'}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayrollSalaryTabUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{display: 'flex'}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Button",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "สร้างการรันเงินเดือน",
          "valueEN": "Create Salary Pay Run"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollSalaryTabUX-Button-6"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickCreateSalary"
        },
        "style": {
          "type": "code",
          "value": "props.getCreateSalaryTabStyle"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Button",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "การจ่ายเงินเดือน",
          "valueEN": "Salary Pay Run"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollSalaryTabUX-Button-7"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickSalaryPayRun"
        },
        "style": {
          "type": "code",
          "value": "props.getSalaryPayRunTabStyle"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayrollSalaryTabUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{ height: '2px', backgroundColor: '#ccc', width: '100%' }"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.renderSalaryTab()"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollSalaryTabUX-div-9"
        }
      },
      "seq": 9,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardPayrollSalaryTabUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
